import { FetchContext, responseErrorHandler } from '..';

export const endUserImpersonation: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<void> = async (fetchContext, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/admin/user-impersonations/me`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'end user impersonation'));
